import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { checkSecurity } from 'components/config/Security';

import Content from 'components/page/Content/Content';
import { FilterProvider } from "context/ContextFilter";
import TrainingList from './HomeTrainingList';
import TrainingFilter from './HomeTrainingFilter';

import 'styles/Home.css';

const Home = () => {
  const navigate = useNavigate();

  const filterRef = useRef('filterRef');


  useEffect(() => {
    // CHECK SECURITY
    checkSecurity(navigate, 'Home');
  }, []);


  //function
  function initFilterMissions(totalsRowParam) {
    filterRef.current.initFilter(totalsRowParam)
  }


  return (
    <Content>
      <FilterProvider>
        <TrainingFilter ref={filterRef} />
        <TrainingList initFilterMissions={initFilterMissions} />
      </FilterProvider>
    </Content>
  );
}

export default Home;